import React, { useEffect, useState } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const ProtectedRoute = (props) => {

    const location = useLocation();



    const match = props.Authen.userRoles?.find((x) => props.allowedRoles.includes(x))

    if (props.Authen.token !== null) {
        if (match.length === 0) {
            return <p>Unauthorised</p>
        }
        else {

            return <Outlet />
        }
    }
    else {
        return <Navigate to="/login" state={{ from: location }} replace />
    }
}
export default ProtectedRoute;
